/**
 * Breakdown menu: multi-screen menu to select event+prop pair
 */
// @ts-check

import {renameEvent} from '../../../report/util';
import {registerMPElement} from 'common/util/register-element';

import {ChildMenu} from '../child-menu';

import template from './index.jade';

class BreakdownMenu extends ChildMenu {
  static get attrsSchema() {
    return {
      ...super.attrsSchema,
      'show-session-event': `boolean`,
    };
  }

  get config() {
    return {
      template,

      defaultState: {
        staged: null,
      },

      helpers: {
        ...super.config.helpers,
        getSelectedEvent: () => this.getSelectedEvent(),
        handleSelectEvent: (ev) => {
          this.hideTooltip();
          this.update({staged: {event: ev.detail.item}, searchFilter: ``});
        },
        handleSelectProperty: (ev) => {
          const property = ev.detail.item;
          this.dispatchEvent(
            new CustomEvent(`select`, {
              detail: {
                item: {
                  event: this.getSelectedEvent(),
                  property,
                },
              },
            }),
          );
        },
      },
    };
  }

  hideTooltip() {
    this.update({tooltipData: null});
  }

  // @ts-ignore
  selectedLabel() {
    const evName = renameEvent(this.getSelectedEventName());
    if (evName) {
      return [
        {label: evName, type: `primary`},
        {label: `by`, type: `secondary`},
        {label: this.getSelectedPropertyName() || `...`, type: `primary`},
      ];
    } else {
      return `Select event...`;
    }
  }
}

export default registerMPElement(`mp-breakdown-menu`, BreakdownMenu);
